import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { founders, team } from "./data";

export default function Team() {
  const members = [
    ...founders.map((f) => ({
      name: f.name,
      subtitle: f.title,
      photo: f.photo,
      items: f.bio,
    })),
    ...team.map((t) => ({
      name: t.name,
      subtitle: t.tags ?? "",
      photo: t.photo,
      items: t.bullets,
    })),
  ];

  return (
    <div className="min-h-screen bg-white text-brand-900">
      <Navbar />

      <section className="pt-32 md:pt-40 pb-16 md:pb-20 bg-brand-50/60">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="inline-block px-6 py-2 rounded-md bg-brand-600 text-white text-lg tracking-wider">專業團隊</div>
          <h1 className="mt-6 font-serif text-3xl md:text-5xl text-brand-800">引領皮膚健康與美業的先鋒</h1>
          <p className="mt-4 text-brand-700/70 max-w-2xl text-sm md:text-base">
            ISHB 匯聚疤痕修復、痛症管理與美業技術的頂尖專家，以專業、安全、有效的技術，守護每一位客戶的肌膚與健康。
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="mb-10">
            <h2 className="font-serif text-2xl md:text-3xl text-brand-800">核心團隊</h2>
            <p className="mt-2 text-sm text-brand-700/60">由國際認證導師與領域專家組成的專業陣容，提供全方位的美業與修復服務</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {members.map((m) => (
              <article key={m.name} className="bg-white border border-brand-100 rounded-lg p-6 md:p-8">
                <div className="flex items-baseline flex-wrap gap-x-3 gap-y-1 mb-2">
                  <h3 className="font-serif italic text-2xl md:text-3xl text-brand-800">{m.name}</h3>
                  {m.subtitle && <span className="text-brand-600 text-sm">{m.subtitle}</span>}
                </div>
                <div className="border-t border-dashed border-brand-200 my-4"></div>
                <div className="flex flex-col md:flex-row gap-6">
                  {m.photo && (
                    <div className="w-full h-60 sm:h-72 md:w-40 md:h-52 shrink-0">
                      <img src={m.photo} alt={m.name} className="w-full h-full object-cover object-[50%_30%] md:object-top rounded-md" />
                    </div>
                  )}
                  <ul className="space-y-2 text-sm text-brand-700/75 leading-relaxed">
                    {m.items.map((b, i) => (
                      <li key={i} className="flex gap-2">
                        <i className="ri-arrow-right-s-fill text-brand-500 mt-0.5"></i>
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/courses"
              className="px-8 py-3 rounded-md bg-brand-600 hover:bg-brand-700 text-white text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
            >
              瀏覽最新課程
            </Link>
            <Link
              to="/treatments"
              className="px-8 py-3 rounded-md border border-brand-300 text-brand-700 hover:bg-brand-50 text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
            >
              了解療程資訊
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}